module.exports = __webpack_public_path__ + "media/dos_personajes.f43a83d4.mp4";